<template lang="html">
  <div>
    <el-table
      :data="datas"
      style="width: 100%">
      <el-table-column
        label="提现时间"
        width="180">
        <template  scope="scope">
          <span>{{scope.row.createTime | dateTimeFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="flowNumber"
        label="流水号"
        width="180">
      </el-table-column>
      <el-table-column
        prop="remitteePhone"
        label="提现账户">
      </el-table-column>
      <el-table-column
        prop="money"
        label="提现金额（元）">
      </el-table-column>
      <el-table-column
        label="提现状态">
        <template  scope="scope">
          <span>{{scope.row.state | withdrawCashStateFilter}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="basic-margin"
      current-page.sync="pageNum"
      @current-change="changePage"
      layout="prev, pager, next"
      :page-size="pageSize"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import ChannelModel from '@/framework/models/channelModel'
import BasicPager from '@/mixins/BasicPager'
export default {
  name: 'withdraw-cash',
  extends: BasicPager,
  data: function () {
    return {
      pageSize: 10,
      total: 0,
      pageNum: 1,
      datas: []
    }
  },
  created: function () {
    this.loadList()
  },
  methods: {
    changePage: function (pageNum) {
      this.pageNum = pageNum
      this.loadList()
    },
    loadList: function () {
      // 不是渠道用户
      if (this.loginInfo.loginPath !== 'channel') {
        return
      }

      // 查询提现列表
      let _this = this
      let params = {
        channelId: this.loginInfo.id,
        pageSize: _this.pageSize,
        pageNum: _this.pageNum
      }
      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.data
          _this.total = dataInfo.recordsTotal
        }
      }

      ChannelModel.findPresentRecordList(_this, params, listener)
    }
  }
}
</script>
